var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "header",
      class: [
        { "is-active--nav": _vm.isActiveNav },
        { "is-loaded--header": _vm.isLoaded },
      ],
    },
    [
      _c("div", {
        staticClass: "header__dimmer",
        on: { click: _vm.handleHolder },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "vn-grid-medium" }, [
        _c("h1", { staticClass: "header__title" }, [
          _c(
            "a",
            { staticClass: "header__link", attrs: { href: "/" } },
            [
              _c("icon-logo", { staticClass: "header__logo" }),
              _vm._v(" "),
              _c("span", { staticClass: "a11y" }, [_vm._v("Fast Campus")]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "nav-opener",
            attrs: { type: "button" },
            on: { click: _vm.handleHolder },
          },
          [_c("icon-menu")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav-holder", on: { scroll: _vm.handleMenuAside } },
          [
            _c("menu-aside", {
              attrs: { "is-active-aside": _vm.isActiveAside },
              on: { "emit-holder": _vm.handleHolder },
            }),
            _vm._v(" "),
            _c("common-utils", {
              attrs: {
                "user-name": _vm.userName,
                "is-authorized": _vm.isAuthorized,
                "is-active-holder": _vm.isActiveHolder,
              },
              on: {
                "emit-sign-in": _vm.handleSignIn,
                "emit-sign-up": _vm.handleSignUp,
                "emit-holder": _vm.handleHolder,
              },
            }),
            _vm._v(" "),
            _c("global-navigation", {
              attrs: { nav: _vm.nav, "is-active-nav": _vm.isActiveNav },
              on: { "emit-header": _vm.handleHeader },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }